// extracted by mini-css-extract-plugin
export default {"sectionCard":"pmHxSeSwVdW6dB9N4udI","sectionCardMobile":"DuNWzPWT_Sz0wzDSxUXt","sectionTitle":"gdOU8aYFkIT07lcic6lq","sectionContent":"JbzcTEF2nMapscS4OE3G"};